import { BillingState } from "@components/billing/BillingState/BillingState";
import { useInlineOrgBillingTransferNotice } from "@components/billing/OrgBillingTransfer/useInlineOrgBillingTransferNotice";
import { useInlineNewVersionNotice } from "@components/newVersion/useInlineNewVersionNotice";
import { useSideNavMode } from "@design-system/SideNav/SideNavProvider";
import { WorkspaceHelpMenu } from "./levelHelpMenus";

/**
 * The workspace nav footer: the help button, then the new-version or billing
 * transfer notice or, without one, the plan / trial chip; a mini nav has only
 * the help button.
 * The help button stays put across those swaps, so a menu open when an
 * update arrives stays open.
 */
export const WorkspaceSideNavFooter = () => {
    const newVersionNotice = useInlineNewVersionNotice();
    const orgBillingTransferNotice = useInlineOrgBillingTransferNotice();
    const isMini = useSideNavMode() === "mini";

    return (
        <>
            <WorkspaceHelpMenu />
            {!isMini &&
                (newVersionNotice ?? orgBillingTransferNotice ?? (
                    <BillingState helpMenu={null} />
                ))}
        </>
    );
};
